import { render, staticRenderFns } from "./b-performance-table.vue?vue&type=template&id=5cf10dfc&scoped=true"
import script from "./b-performance-table.vue?vue&type=script&lang=js"
export * from "./b-performance-table.vue?vue&type=script&lang=js"
import style0 from "./b-performance-table.vue?vue&type=style&index=0&id=5cf10dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf10dfc",
  null
  
)

export default component.exports